import { render, staticRenderFns } from "./TestPriceContainer.vue?vue&type=template&id=3761e85f"
import script from "./TestPriceContainer.vue?vue&type=script&lang=js"
export * from "./TestPriceContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports